import { render, staticRenderFns } from "./CreateFixedDepositCard.vue?vue&type=template&id=58086456&scoped=true&"
import script from "./CreateFixedDepositCard.vue?vue&type=script&lang=js&"
export * from "./CreateFixedDepositCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58086456",
  null
  
)

export default component.exports